import { useEffect, useState } from "react";
import { Gate } from "../permissions/PermissionContext";
import { Link } from "react-router-dom";
import { api } from "../api/client";
import { Badge, Spinner } from "../components/UI";
import dayjs from "dayjs";
import "dayjs/locale/de";
dayjs.locale("de");

export default function Dashboard() {
  const [sitzungen, setSitzungen] = useState([]);
  const [beschluesse, setBeschluesse] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.getSitzungen(), api.getBeschluesse()])
      .then(([s, b]) => { setSitzungen(s); setBeschluesse(b); })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  const naechste = sitzungen.filter(s => s.status !== "abgesagt"
  ).slice(0, 5);

  const offeneBeschluesse = beschluesse.filter(b => b.status === "offen").length;
  const inBearbeitung = beschluesse.filter(b => b.status === "in_bearbeitung").length;
  const faellig = beschluesse.filter(b =>
    b.faellig_am && dayjs(b.faellig_am).isBefore(dayjs().add(7, "day")) && b.status !== "erledigt"
  ).length;

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="breadcrumb">Übersicht</div>
          <h2>Dashboard</h2>
        </div>
        <div className="page-actions">
          <Gate perm="sitzung.erstellen"><Link to="/sitzungen/neu" className="btn btn-primary">+ Neue Sitzung</Link></Gate>
        </div>
      </div>

      <div className="content">
        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">📋</div>
            <div className="stat-value">{sitzungen.length}</div>
            <div className="stat-label">Sitzungen gesamt</div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🔔</div>
            <div className="stat-value">{naechste.length}</div>
            <div className="stat-label">Kommende Sitzungen</div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">✓</div>
            <div className="stat-value" style={{ color: "var(--warn)" }}>{offeneBeschluesse}</div>
            <div className="stat-label">Offene Beschlüsse</div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">⚠</div>
            <div className="stat-value" style={{ color: "var(--danger)" }}>{faellig}</div>
            <div className="stat-label">Bald fällig (7 Tage)</div>
          </div>
        </div>

        <div className="grid-2">
          <div className="card">
            <div className="card-header">
              <h3>Sitzungen</h3>
            </div>
            <div className="card-body" style={{ padding: 0 }}>
              {naechste.length === 0 ? (
                <div className="empty-state">
                  <div className="empty-icon">📅</div>
                  <p>Keine kommenden Sitzungen</p>
                </div>
              ) : (
                <table className="table">
                  <tbody>
                    {naechste.map(s => (
                      <tr key={s.id}>
                        <td>
                          <Link to={`/sitzungen/${s.id}`} style={{ textDecoration: "none", color: "inherit" }}>
                            <div style={{ fontWeight: 500 }}>{s.titel}</div>
                            <div style={{ fontSize: 12, color: "var(--ink-faint)" }}>
                              {dayjs(s.datum).format("dd, DD.MM.YYYY HH:mm")} Uhr
                            </div>
                          </Link>
                        </td>
                        <td><Badge status={s.status} /></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <h3>Offene Beschlüsse</h3>
              <Link to="/beschluesse" className="btn btn-ghost btn-sm ml-auto">Alle →</Link>
            </div>
            <div className="card-body" style={{ padding: 0 }}>
              {beschluesse.filter(b => b.status !== "erledigt").length === 0 ? (
                <div className="empty-state">
                  <div className="empty-icon">✅</div>
                  <p>Alle Beschlüsse erledigt</p>
                </div>
              ) : (
                <table className="table">
                  <tbody>
                    {beschluesse.filter(b => b.status !== "erledigt").slice(0, 5).map(b => (
                      <tr key={b.id}>
                        <td>
                          <div style={{ fontWeight: 500, fontSize: 13 }}>{b.text.substring(0, 60)}{b.text.length > 60 ? "…" : ""}</div>
                          {b.verantwortlich && (
                            <div style={{ fontSize: 11, color: "var(--ink-faint)" }}>→ {b.verantwortlich}</div>
                          )}
                          {b.faellig_am && (
                            <div style={{ fontSize: 11, color: dayjs(b.faellig_am).isBefore(dayjs()) ? "var(--danger)" : "var(--ink-faint)" }}>
                              Fällig: {dayjs(b.faellig_am).format("DD.MM.YYYY")}
                            </div>
                          )}
                        </td>
                        <td><Badge status={b.status} /></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
